/**
 * Helpers for locating and updating fields in a recursive extraction schema
 * using index paths (e.g. [0], [1, 2] for nested table fields).
 */

/** Return the field at ``path`` (array of indices) or null. */
export function getFieldAtPath(fields, path) {
  const list = Array.isArray(fields) ? fields : []
  if (!Array.isArray(path) || path.length === 0) return null
  let node = list[path[0]]
  for (let i = 1; i < path.length; i += 1) {
    const sub = node?.object_type?.fields
    if (!Array.isArray(sub)) return null
    node = sub[path[i]]
  }
  return node || null
}

/** Replace the field at ``path`` with ``nextField``; returns a new fields array. */
export function applyFieldAtPath(fields, path, nextField) {
  const list = Array.isArray(fields) ? fields : []
  if (!Array.isArray(path) || path.length === 0) return list
  if (path.length === 1) {
    return list.map((f, i) => (i === path[0] ? nextField : f))
  }
  const [head, ...rest] = path
  return list.map((f, i) => {
    if (i !== head) return f
    const ot = f?.object_type || {}
    return {
      ...f,
      object_type: {
        ...ot,
        object_list: ot.object_list || "object_list",
        fields: applyFieldAtPath(ot.fields, rest, nextField),
      },
    }
  })
}

/** Human-readable path label for UI, e.g. "cohorts › complications". */
export function fieldPathLabel(fields, path) {
  const names = []
  let list = fields
  for (const idx of path || []) {
    const f = Array.isArray(list) ? list[idx] : null
    if (!f) break
    names.push(f.object_name || `field_${idx}`)
    list = f?.object_type?.fields
  }
  return names.join(" › ") || "field"
}
